import { Card, Image } from "antd";
import { useTranslation } from "react-i18next";
import card1 from "./images/card-1.png";
import card2 from "./images/card-2.png";
import card3 from "./images/card-3.png";
import card4 from "./images/card-4.png";
import card5 from "./images/card-5.png";
import card6 from "./images/card-6.png";
import styles from "./style.module.scss";

const Advantages = () => {
  const { t } = useTranslation();

  const cardsEnum = [
    {
      src: card1,
      title: "home.advantages.card.title1",
      content: "home.advantages.card.content1",
    },
    {
      src: card2,
      title: "home.advantages.card.title2",
      content: "home.advantages.card.content2",
    },
    {
      src: card3,
      title: "home.advantages.card.title3",
      content: "home.advantages.card.content3",
    },
    {
      src: card4,
      title: "home.advantages.card.title4",
      content: "home.advantages.card.content4",
    },
    {
      src: card5,
      title: "home.advantages.card.title5",
      content: "home.advantages.card.content5",
    },
    {
      src: card6,
      title: "home.advantages.card.title6",
      content: "home.advantages.card.content6",
    },
  ];

  const renderCards = cardsEnum.map((item, index) => {
    return (
      <Card key={index} className={styles.card}>
        <div className={styles.imgContainer}>
          <Image src={item?.src} alt="img" preview={false} className={styles.img} />
        </div>
        <div className={styles.title}>{t(item.title)}</div>
        <div className={styles.content}> {t(item.content)} </div>
      </Card>
    );
  });

  return <div className={styles.advantages}>{renderCards}</div>;
};

export default Advantages;
